import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import {
  initializeLocalNotifications,
  removeLocalNotificationListeners,
  isLocalNotificationsSupported,
  checkNotificationPermission,
  requestLocalNotificationPermission,
  isNativePlatform,
} from '@/services/localNotificationService';

export const useLocalNotifications = () => {
  const { user } = useAuth();
  const [isInitialized, setIsInitialized] = useState(false);
  const [isSupported, setIsSupported] = useState(false);
  const [permissionGranted, setPermissionGranted] = useState(false);

  useEffect(() => {
    setIsSupported(isLocalNotificationsSupported());
  }, []);

  useEffect(() => {
    if (!user?.id || !isSupported) return;

    const initNotifications = async () => {
      try {
        const success = await initializeLocalNotifications();
        setIsInitialized(success);
        
        const hasPermission = await checkNotificationPermission();
        setPermissionGranted(hasPermission);
        
        if (success) {
          console.log(`Local notifications initialized (native: ${isNativePlatform()})`);
        } else {
          console.log('Local notifications not available');
        }
      } catch (error) {
        console.warn('Local notifications initialization failed:', error);
        setIsInitialized(false);
        setPermissionGranted(false);
      }
    };

    initNotifications();

    return () => {
      if (isNativePlatform()) {
        removeLocalNotificationListeners().catch((e) => {
          console.warn('Failed to remove notification listeners:', e);
        });
      }
    };
  }, [user?.id, isSupported]);

  const requestPermission = async () => {
    const granted = await requestLocalNotificationPermission();
    setPermissionGranted(granted);
    return granted;
  };

  return {
    isInitialized,
    isSupported,
    permissionGranted,
    requestPermission,
    isNative: isNativePlatform(),
  };
};
